import App from "@frog/source/models/App.js"
import Director from "@frog/source/juice/Director.js"

import pixel from "@frog/source/views/utility/pixel.js"
import * as Objdict from "objdict"
import Geometry from "@frog/source/utility/Geometry.js"
import skills from "@frog/source/data/skills/skills.js"
import World from "@frog/source/models/World.js"
import {getTime} from "@frog/source/juice/utility/Time.js"

// import Colors from "@frog/source/data/colors.js"
const Colors = {
    "yellow": "#fed429",
    "red": "#EC4E20",
    "green": "#33CA7F",
    "black": "#2E382E",
    "blue": "#2589BD",
    "white": "#FFFFFF",
}

const PLAYER_AFFILIATION = "good"

const RANGE_IMAGES = {
    "invoke skill": require("@frog/source/assets/images/apocalypse-tactics/ui/range/red-range.png").default,
    "invoke skill support": require("@frog/source/assets/images/apocalypse-tactics/ui/range/green-range.png").default,
    "move": require("@frog/source/assets/images/apocalypse-tactics/ui/range/blue-range.png").default,
}

RANGE_IMAGES["move through"] = RANGE_IMAGES["move"]
RANGE_IMAGES["wait-for-move"] = RANGE_IMAGES["move"]

// const ROTATIONS = {}
// const MAX_ROTATION = 10
// for(let x = 0; x < 6; x += 1) {
//     for(let y = 0; y < 6; y += 1) {
//         ROTATIONS[x + "x" + y] = (Math.random() * MAX_ROTATION) - (MAX_ROTATION / 2)
//     }
// }

const RANGE_COLORS = {
    "move": Colors.blue,
    "invoke skill": Colors.red,
    "invoke skill support": Colors.green,
}

export default function ActionRangeLayer(stage) {
    if(Director.isPerforming == true) return

    const range = Object.values(stage.units).map((unit) => {
        if(App.game.encounter.selection.selectedUnitKey == unit.key) {
        // || App.game.encounter.selection.watchedUnits[App.game.encounter.selection.selectedUnitKey || App.game.encounter.selection.hoveredUnitKey] == true) {
            return UnitActionRange(stage, unit)
        }
        if(App.game.encounter.selection.selectedUnitKey == undefined
        && App.game.encounter.selection.hoveredUnitKey == unit.key) {
        // || App.game.encounter.selection.watchedUnits[App.game.encounter.selection.selectedUnitKey || App.game.encounter.selection.hoveredUnitKey] == true) {
            return UnitActionRange(stage, unit)
        }
    }).filter((view) => view != undefined)
    // .concat([
    //     // DangerzoneSprites(stage),
    // ])

    // return [
    //     DangerzoneSprites(stage),
    //     Object.values(stage.units).map((unit) => {
    //         if(App.game.encounter.selection.activeUnitKey == unit.key
    //         || App.game.encounter.selection.watchedUnits[unit.key] == true) {
    //             return UnitActionRange(stage, unit)
    //         }
    //     }).filter((view) => view != undefined)
    // ]

    return range
    // return {
    //     "_": range
    // }
}

// function DangerzoneSprites(stage) {
//     if(stage.dangerzones == undefined) {
//         stage.dangerzones = {}
//         Objdict.forEach(stage.units, (unit) => {
//             // if(App.game.encounter.selection.isRenderingDangerzone != true) return
//             if(unit.affiliation != "bad") return
//
//             let actionmap = unit.actionmap
//             if(stage.nextTurn != undefined
//             && stage.nextTurn.aiActions != undefined
//             && stage.nextTurn.aiActions[unit.key] != undefined
//             && stage.nextTurn.aiActions[unit.key].actionmap != undefined) {
//                 actionmap = stage.nextTurn.aiActions[unit.key].actionmap
//             }
//             if(actionmap == undefined) return
//
//             Objdict.forEach(actionmap, (actionlist, positionKey) => {
//                 const action = App.game.encounter.selection.findActionInActionlist({unit, actionlist})
//                 if(action == undefined) return
//
//                 stage.dangerzones[positionKey] = action.position
//             })
//         })
//     }
//
//     return Object.values(Objdict.map(stage.dangerzones, (position, positionKey) => {
//         const terrain = World.getTerrain(stage.world, position)
//         if(terrain == undefined) return
//
//         return {
//             "key": "dangerzone/" + positionKey,
//             "width": 16,
//             "height": 16,
//             "anchor": {"x": "50%", "y": "100%"},
//             "opacity": 0.33,
//             "color": RANGE_COLORS["invoke skill"],
//             "position": pixel("range", {
//                 "x": terrain.position.x,
//                 "y": terrain.position.y,
//                 "z": terrain.position.z + terrain.size.z,
//             }),
//         }
//     }))
// }

import {getFrameFromAnimation} from "@frog/source/juice/utility/getFrameFromAnimation.js"
const startTimestamp = Date.now()

function UnitActionRange(stage, unit, options = {}) {
    if(unit == undefined) return
    if(unit.isDead == true) return

    let actionmap = unit.actionmap
    if(stage.nextTurn != undefined
    && stage.nextTurn.aiActions != undefined
    && stage.nextTurn.aiActions[unit.key] != undefined
    && stage.nextTurn.aiActions[unit.key].actionmap != undefined) {
        actionmap = stage.nextTurn.aiActions[unit.key].actionmap
    }
    if(actionmap == undefined) return

    return Object.values(actionmap).map((actionlist, positionKey) => {
        const action = App.game.encounter.selection.findActionInActionlist({unit, actionlist})
        if(action == undefined) return

        const terrain = World.getTerrain(stage.world, action.position)
        if(terrain == undefined) return

        let type = action.type
        if(action.skillKey != undefined
        && skills.get(action.skillKey) != undefined
        && skills.get(action.skillKey).class == "support") {
            type = "invoke skill support"
        }

        if(unit.affiliation != PLAYER_AFFILIATION) {
            type = "invoke skill"
        }

        let image
        if(RANGE_IMAGES[type] == undefined) return
        if(RANGE_IMAGES[type].isAnimation == true) {
            const totalDuration = Date.now() - startTimestamp

            image = getFrameFromAnimation(RANGE_IMAGES[type], totalDuration).image
        } else {
            image = RANGE_IMAGES[type]
        }

        const distance = Geometry.distance(action.position, App.game.encounter.selection.position)
        const selectedDuration = getTime().ms - Math.min(App.game.encounter.selection.selectedTime ?? Infinity, App.game.encounter.selection.hoveredTime ?? Infinity)

        // const ROLLOUT_SPEED = 75 // IN MS, HOW LONG TO DWELL ON EACH TILE TO ROLL OUT
        // if(distance > selectedDuration / ROLLOUT_SPEED) {
        //     return
        // }

        return {
            "key": "unit/" + unit.key + "/range/" + positionKey,
            // "width": 16,
            // "height": 16,
            "anchor": {"x": "50%", "y": "100%"},
            "opacity": 0.5, // App.game.encounter.selection.selectedUnitKey == unit.key ? (type == "invoke skill" ? 0.7 : 0.8) : (type == "invoke skill" ? 0.6 : 0.7),
            "blendmode": "cool",
            // "tint": {
            //     "color": "white",
            //     "intensity": 0.2,
            // },
            "image": image,
            "position": pixel("range", {
                "x": terrain.position.x,
                "y": terrain.position.y,
                "z": terrain.position.z + terrain.size.z,
            }),
        }
    })
}
